module.exports = __webpack_public_path__ + "img/paysmartLogoM.c165b42b.png";